module.exports = __webpack_public_path__ + "img/02.5ddb124d.gif";